<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_manageapprovetransferrole/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
